import { Backdrop, Button, Paper, Menu, MenuItem, styled } from "@mui/material";

import useWindowDimensions from "../../hooks/useWindowDimension";
import colors from "../../theme/themeConstants";

import edit_icon from "../icons/edit_icon.svg";
import share_icon from "../icons/share_icon_red.svg";
import manage_icon from "../icons/manage_icon.svg";

export const CollectionEditMenu = (props: {
  anchor: HTMLElement;
  onClose: () => void;
  onEdit: () => void;
  onShare: () => void;
  onManage: () => void;
  canShare: boolean;
}): JSX.Element => {
  const isDesktop = useWindowDimensions();

  const handleStopPropagation = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  if (isDesktop) {
    return (
      <Menu
        anchorEl={props.anchor}
        open={true}
        onClose={props.onClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        sx={{
          "& div": {
            borderRadius: "12px",
            paddingTop: "8px",
            paddingBottom: "8px",
          },
          "& ul": { padding: 0 },
          "& li": {
            fontSize: "14px",
            fontWeight: 500,
            paddingLeft: "20px",
            "& img": {
              marginRight: "8px",
              maxHeight: "12px",
            }
          }
        }}
      >
        <MenuItem onClick={props.onEdit}><img src={edit_icon} alt="" />Edit</MenuItem>
        {props.canShare && <MenuItem onClick={props.onShare}><img src={share_icon} alt="" />Share</MenuItem>}
        <MenuItem onClick={props.onManage}><img src={manage_icon} alt="" />Manage</MenuItem>
      </Menu>
    );
  }

  return (
    <Backdrop open={true} id="CollectionEditMenu"
      sx={{
        zIndex: 500
      }}
      onClick={props.onClose}
    >
      <Paper
        onClick={handleStopPropagation}
        sx={{
          height: "auto",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          maxWidth: "25rem",
          position: "absolute",
          bottom: "0rem", // isOpen ? "0rem" : "-15rem"
          transition: "bottom 300ms cubic-bezier(0, 0, 1, 1) 0ms",
          borderRadius: "24px",
          padding: "2rem 1rem 0 1rem",
          zIndex: 100,
          "@media screen and (max-width: 767px)": {
            borderRadius: 0,
            maxWidth: "unset",
            borderTopLeftRadius: "24px",
            borderTopRightRadius: "24px",
          },
        }}
      >
        <MobileHandler
          onClick={props.onClose}
        />
        <SharingButtons>
          <SharingButton
            onClick={props.onEdit}
          >
            <img src={edit_icon} alt={"edit"}/>
            <span>Edit</span>
          </SharingButton>
          {props.canShare && (
            <SharingButton
              onClick={props.onShare}
            >
              <img src={share_icon} alt="" />
              <span>Share</span>
            </SharingButton>
          )}
          <SharingButton
            onClick={props.onManage}
          >
            <img src={manage_icon} alt="" />
            <span>Manage</span>
          </SharingButton>
        </SharingButtons>
      </Paper>
    </Backdrop>
  );
};

const MobileHandler = styled("div")({
  background: "rgba(216, 223, 236, 0.7)",
  borderRadius: "12px",
  width: "32px",
  height: "4px",
  alignSelf: "center",
  marginBottom: "1rem"
});

const SharingButtons = styled("div")({
  display: "flex",
  margin: "1.5rem 0 2rem",
  justifyContent: "space-between",
  gap: "1rem"
});

const SharingButton = styled(Button)({
  backgroundColor: colors.lightGrayPaperBackground,
  color: colors.textDark,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  borderRadius: "12px",
  paddingTop: "16px",
  paddingBottom: "16px",
  minWidth: "unset",
  "& img": {
    width: "15px"
  }
});
